import React from 'react'
import { makeStyles, createStyles, Box, Paper, GridList, Link } from '@material-ui/core/'
import { ReactComponent as Facebook } from 'src/mobile/assets/icons/Facebook.svg'
import { ReactComponent as YouTube } from 'src/mobile/assets/icons/YouTube.svg'
import { ReactComponent as Linkedin } from 'src/mobile/assets/icons/Linkedin.svg'
import { SITE_MATE_DATA } from 'src/utils/constant'

const useStyles = makeStyles((theme) =>
  createStyles({
    paper: {
      height: '100%',
      borderRadius: 6,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
  }),
)

const MEDIA_LIST = [
  { label: 'Take2 Health', href: SITE_MATE_DATA.FACEBOOK, icon: <Facebook /> },
  { label: 'Take2 Health', href: SITE_MATE_DATA.YOUTUBE, icon: <YouTube /> },
  { label: 'Take2 Health', href: SITE_MATE_DATA.LINKEDIN, icon: <Linkedin /> },
]

const Follow = () => {
  const classes = useStyles()

  return (
    <Box mx={4} py={2}>
      <GridList className={classes.appointmentWrapper} cols={2} cellHeight={160} spacing={8}>
        {MEDIA_LIST.map((media, index) => (
          <Box key={index}>
            <Paper
              className={classes.paper}
              href={media.href}
              variant="outlined"
              elevation={0}
              underline="none"
              component={Link}
              target="_blank"
            >
              {media.icon}
              <Box fontSize="body1.fontSize" mt={2} color="grey.600">
                {media.label}
              </Box>
            </Paper>
          </Box>
        ))}
      </GridList>
    </Box>
  )
}

export default Follow
